<template>
  <div id="app" class="app">
    <auth-layout v-if="isAuth"></auth-layout>
    <empty-layout v-if="isScreenShare || isPublic"></empty-layout>
    <layout v-if="isLayout" />
    <other-layout v-if="isOther"></other-layout>
  </div>
</template>

<script>
  import Layout from 'components/layout/Layout'
  import AuthLayout from 'components/layout/AuthLayout'
  import EmptyLayout from 'components/layout/EmptyLayout'
  import OtherLayout from 'components/layout/OtherLayout'
  import VuesticPreLoader from 'vuestic-components/vuestic-preloader/VuesticPreLoader.vue'

  export default {
    name: 'app',
    components: {
      VuesticPreLoader,
      AuthLayout,
      EmptyLayout,
      OtherLayout,
      Layout
    },
    mounted () {
      this.setFavicon()
    },
    methods: {
      setFavicon () {
        const hostname = window.location.hostname

        // Remove existing favicon links to avoid conflicts
        const existingLinks = document.querySelectorAll("link[rel*='icon']")
        existingLinks.forEach(link => link.remove())

        // Create new favicon link
        const link = document.createElement('link')
        link.type = 'image/x-icon'
        link.rel = 'shortcut icon'

        if (hostname.includes('fonestorm')) {
          // Try multiple possible paths
          link.href = '/static/fonestorm/favicon.ico'
          document.title = 'FoneStorm Dashboard'
        } else {
          // Try multiple possible paths for FracTEL
          link.href = '/static/fractel/favicon.ico'
          document.title = 'FracTEL Dashboard'
        }

        document.getElementsByTagName('head')[0].appendChild(link)

        // Force browser to reload favicon
        link.href = link.href + '?v=' + new Date().getTime()
      },
    },
    computed: {
      isAuth () {
        return this.$route.path.match('auth')
      },
      isScreenShare () {
        return this.$route.path.match('screenshare')
      },
      isLayout () {
        return this.$route.path.match('auth') === null && this.$route.path.match('screenshare') === null && this.$route.path !== '/' && !this.$route.meta.otherLayout && !this.$route.meta.public
      },
      isOther () {
        return this.$route.meta.otherLayout
      },
      isPublic () {
        return this.$route.meta.public
      }
    }
  }
</script>

<style lang="scss">
  @import "sass/main";

  body {
    height: 100%;
    #app {
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue